import { useMutation } from '@apollo/client/react'
import React, { FC, useContext } from 'react'
import { Wrapper } from '@src/components/Elements'
import { Form } from '../Form'
import { FormValues } from '../Form/Form'
import { TestIds } from '@src/global'
import { useTranslation } from 'react-i18next'
import { ToastContext, TOAST_TYPES } from '@src/components/Providers'
import { Account } from '@src/graphql/Account'

export interface AddProps {
  closeModal: () => void
}

export const Add: FC<AddProps> = ({ closeModal }) => {
  const { t } = useTranslation()
  const { setToast } = useContext(ToastContext)
  const [createOrder, { error }] = useMutation(Account.createAccount)

  const onSubmit = async (variables: FormValues) => {
    try {
      const { data: data_ } = await createOrder({
        variables,
        refetchQueries: ['accounts'],
      })

      if (data_) {
        closeModal()
        setToast({
          type: TOAST_TYPES.SUCCESS,
          message: t('desktop.pages.accounts.add.form.success.message'),
          description: t('desktop.pages.accounts.add.form.success.description'),
        })
      }
    } catch {
      return false
    }
  }

  return (
    <div data-testid={TestIds.pages.orders.add.identifier}>
      <Wrapper>
        <Form onSubmit={onSubmit} error={error} />
      </Wrapper>
    </div>
  )
}
